import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { ChevronLeft, Heart } from "lucide-react";
import { notification } from "antd";
import { useState } from "react";

import IllustrationHeader from "../../assets/Idea/Idea1.png";
import IllustrationBody from "../../assets/Idea/Idea2.png";
import variables from "../../styles/variables.module.scss";
import ideasServices from "../../services/ideasServices";
interface KanbanIdeaProps {
	idea: any;
	back: () => void;
}

export default function KanbanIdea({ idea, back }: KanbanIdeaProps) {
	const [isVoted, setIsVoted] = useState(false);
	const areas: any = idea.hospital_areas;
	const status: string = idea.status;
	const hospitals: any = idea.hospital_units;
	const authors: any = idea.authors;

	const upvote = (ideaId: number) => {
		ideasServices.upVote(ideaId).then(() =>
			notification.success({
				message: "¡Muchas gracias por tu voto!",
			}),
		);
	};

	const deleteVote = async (ideaId: number) => {
		ideasServices.deleteVote(ideaId).then(() =>
			notification.success({
				message: "¡Se eliminó tu voto!",
			}),
		);
	};

	const getStatusColor = (status: string) => {
		let statusColor = "";

		switch (status) {
			case "IDEA":
				statusColor = variables.secondary2_300;
				break;
			case "EN REVISION":
				statusColor = variables.secondary1_500;
				break;
			case "DESARROLLO":
				statusColor = variables.secondary2_600;
				break;
			case "FINALIZADO":
				statusColor = variables.primary900;
				break;
			case "IMPLEMENTACION":
				statusColor = variables.primary2_900;
				break;
			case "BACKLOG":
				statusColor = variables.neutral400;
				break;
		}
		return statusColor;
	};

	const handleVote = async (idea: any) => {
		if (isVoted) {
			await deleteVote(idea);
			setIsVoted(false);
		} else {
			await upvote(idea);
			setIsVoted(true);
		}
		await new Promise((res) => setTimeout(res, 1000));
	};

	return (
		<Box className="idea">
			<Box className="idea__background">
				<img
					className="idea__background__header"
					src={IllustrationHeader}
					alt=""
				/>

				<img
					className="idea__background__body"
					src={IllustrationBody}
					alt=""
				/>
			</Box>

			<Button onClick={() => back()}>
				<ChevronLeft />
				Regresar
			</Button>

			<Box className="idea__card">
				<Box className="idea__card__header">
					<Typography
						className={`idea__card__header__status ${getStatusColor(status)}`}
					>
						{status
							.toLowerCase()
							.split(" ")
							.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
							.join(" ")}
					</Typography>

					{!isVoted ? (
						<Stack flexDirection={"row"}>
							<Stack
								textAlign={"end"}
								justifyContent={"center"}
							>
								<Typography>¿Te agrada esta idea?</Typography>
								<Typography>¡Dale "Me gusta"!</Typography>
							</Stack>
							<IconButton onClick={() => handleVote(idea["idea_id"])}>
								<Heart />
							</IconButton>
						</Stack>
					) : (
						<Stack flexDirection={"row"}>
							<Stack
								textAlign={"end"}
								justifyContent={"center"}
							>
								<Typography>¡Ya votaste por esta idea!</Typography>
								<Typography>Oprime para eliminar tu voto</Typography>
							</Stack>
							<IconButton onClick={() => handleVote(idea["idea_id"])}>
								<Heart fill="white" />
							</IconButton>
						</Stack>
					)}
				</Box>

				<Box className="idea__card__body">
					<Typography>{idea["title"]}</Typography>

					<Box className="idea__card__body__params">
						<Box className="idea__card__body__params__subtitle">
							<Typography>Unidad:</Typography>
							<Typography>Área(s):</Typography>
							<Typography>Categoría:</Typography>
							<Typography>Autor(es):</Typography>
						</Box>

						<Box className="idea__card__body__params__info">
							<Typography>
								{hospitals
									.map((hospital: any) => `${hospital["name"]}`)
									.join(", ")}
							</Typography>

							<Typography>
								{areas
									.map((area: any) => `${area["area_name"]}`)
									.join(", ")}
							</Typography>

							<Typography>
								{idea.category_name === null ? "-" : idea.category_name}
							</Typography>

							<Typography>
								{authors
									.map(
										(author: any) =>
											`${author["first_name"]} ${author["last_name"]}`,
									)
									.join(", ")}
							</Typography>
						</Box>
					</Box>

					<Box className="idea__card__body__description">
						<Typography>{idea.description}</Typography>
					</Box>

					<Box className="idea__card__body__resources">
						<Typography>Recursos necesarios:</Typography>
						<Typography>
							{idea.resources === null || idea.resources === undefined
								? "-"
								: idea.resources}
						</Typography>
					</Box>
				</Box>
			</Box>
		</Box>
	);
}
